import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData, State } from '../../types'
import { DirectionArrow } from '../shared/DirectionArrow'
import { DifferenceInCases, StyledGridTable } from './JabTracker.styled'

export function TableCell({
    datakey,
    data,
    type,
}: {
    datakey: string
    data: FormattedData
    type: 'large' | 'small' | undefined
}) {
    const stateData = data[datakey as State]
    const caseDirection =
        stateData && stateData.cases.dailyDifference > 1 ? 'up' : 'down'
    const dailyActiveCases = stateData.cases.dailyActive
    const dailyDifference = stateData.cases.dailyDifference
    // Remove total count from list on small version
    if (type === 'small' && datakey === 'AUS') {
        return null
    }

    return (
        <div className="StyledGridTable--FlexCell">
            <div className="StyledGridTable--FlexCell__left">
                <div className="StyledGridTable--StateKey">{datakey}</div>
                <div className="StyledGridTable--Number">
                    {numberWithCommas(dailyActiveCases)}
                </div>
            </div>
            <div className="StyledGridTable--FlexCell__right">
                {dailyActiveCases !== 0 && (
                    <DifferenceInCases type={type} direction={caseDirection}>
                        {DirectionArrow({
                            direction: caseDirection,
                        })}
                        {numberWithCommas(dailyDifference)}
                    </DifferenceInCases>
                )}
            </div>
        </div>
    )
}

export function ActiveCasesTable({
    data,
    type,
}: {
    data: FormattedData
    type: 'large' | 'small'
}) {
    // DTEC589 - Editorial req : Total, then WA then the rest of the states in alphabetical order
    const waAndTotal = (state: string) => state !== 'AUS' && state !== 'WA'
    const otherStates = (state: string) => state == 'AUS' || state == 'WA'

    const filteredKeys = Object.keys(data).filter(waAndTotal).sort()

    const totalAndWaKeys = Object.keys(data).filter(otherStates).sort()

    return (
        <>
            <StyledGridTable type={type}>
                {totalAndWaKeys.map((key) => (
                    <TableCell
                        key={key}
                        datakey={key}
                        data={data}
                        type={type}
                    />
                ))}
                {filteredKeys.map((key) => (
                    <TableCell
                        key={key}
                        datakey={key}
                        data={data}
                        type={type}
                    />
                ))}
            </StyledGridTable>
        </>
    )
}
